const locale = {
	userMenu: {
		profile: 'My profile',
		signOut: 'Sign out'
	},
	footer: {
		acceptTerms: 'Terms and conditions',
		privacyPolicy: 'Privacy Policy'
	},
	navbar: {
		guest: 'Guest',
		logoName: 'FRAIME'
	},
	toolbar: {
		fullscreen: 'Fullscreen toggle',
		login: 'Login',
		register: 'Register'
	},
	licenseType: {
		ram: 'Memory: ',
		noLicense: 'No License',
		freeUser: 'Free',
		premiumUser: 'Premium',
		testUser: 'Test',
		queries: 'Queries count: ',
		customModel: 'Training: ',
		diskSpace: 'Disk space: ',
		fileSizeLimit: 'File size limit: ',
		unlimited: ' Unlimited',
		aggregationLimit: 'Aggregation limit: ',
		imageDimensionLimit: 'Image dimension limit: ',
		hasCustomService: 'Has custom service: ',
		startDate: 'Started At: ',
		endDate: 'Expires At: '
	}
};
export default locale;
